// extracted by mini-css-extract-plugin
export default {"fileContainer":"Documents_fileContainer__+7-BX"};